import React, {useEffect, useState} from "react";
import {Step, StepContainer, StepMachine} from 'react-step-machine';
import CloudWorkloads from "./steps/cloud-workloads";
import OffCloudWorkloads from "./steps/off-cloud-workloads";
import Assistance from "./steps/assistance";
import ContactInfo from "./steps/contact-info";
import {ProgressBar} from "./progress-bar";
import axios from "axios";


export const PreAssessmentFormWizard = ({onSubmitted}) => {
    const [data, setData] = useState({}); // storage to data from all steps
    const [customErrors, setCustomErrors] = useState([]);  // custom error like from HS one

    const mergeStepData = (stepData) => {
        setData({...data, ...stepData});
        setCustomErrors([]);
        return true;
    }

    const onFinalSubmit = (stepData) => {
        // mergeStepData(stepData);
        const finalData = {...data, ...stepData};
        // alert(JSON.stringify(finalData, null, 2));
        console.log("Final data:", finalData);

        const contactProps = ['firstname', 'lastname', 'salutation', 'company', 'phone', 'email']
        const fields = Object.entries(finalData).map(([k, v]) => {
            return {
                objectTypeId: contactProps.includes(k) ? '0-1' : '0-2',
                name: k,
                value: Array.isArray(v) ? v.join(';') : v
            }
        })
        if (typeof window !== "undefined" && window.previousPath) {
            fields.push({name: "webformmetadata", value: window.previousPath})
        }

        let dataToSubmit = {
            fields,
            legalConsentOptions: {
                consent: {
                    // Include this object when GDPR options are enabled
                    consentToProcess: true,
                    text:
                        'I agree to allow Cloudnexa, Inc. to store and process my personal data.',
                },
            },
            context: {
                pageName: 'Cloudnexa Preassessment',
                pageUri: window.location.href,
            },
        };

        console.log("Submission data:", dataToSubmit)

        axios
            .post(`${process.env.GATSBY_HUBSPOT_PREASSESSMENT_FORM_URL}`, dataToSubmit)
            .then((response) => {
                onSubmitted(true);
                return true;
            }).catch((error) => {
            console.log("Error:", error.response)
            const errorMessages = [error.response.data.message].concat(error.response.data.errors.map(e => e.message));
            setCustomErrors(errorMessages);
            return false;
        });
    }

    useEffect(() => {
        console.log("Data:", data);
    }, [data]);

    return (
        <div>
            <StepMachine>
                <ProgressBar />
                <div className='wizardForm'>
                    <StepContainer>
                        <Step order={1}><CloudWorkloads data={data} onNext={mergeStepData} /></Step>
                        <Step order={2}><OffCloudWorkloads data={data} onNext={mergeStepData} /></Step>
                        <Step order={3}><Assistance data={data} onNext={mergeStepData} /></Step>
                        <Step order={4}><ContactInfo data={data} onNext={onFinalSubmit} customErrors={customErrors} /></Step>
                    </StepContainer>
                </div>
            </StepMachine>
        </div>
    )
}